
import { Component, Vue, Watch } from 'vue-property-decorator'
import basicInformation from './basicInformation.vue'
import { AppModule } from '@/store/modules/app'

@Component({
  name: 'addMerchant',
  components: {
    basicInformation
  }
})
export default class extends Vue {
  @Watch('steps')
  private onStepsChange () {
    this.initSteps()
  }
  private stepsOptions: any = {
    titleList: [],
    tips: ''
  }
  private steps: number = 0
  private back () {
    this.$emit('close')
  }
  private next () {
    if (this.steps === 1) {
      this.steps = 0
      this.back()
    } else {
      this.steps++
    }
  }

  get language () {
    return AppModule.language
  }

  private initSteps () {
    switch (this.steps) {
      case 0:
        if (this.language === 'en') {
          this.stepsOptions.titleList = ['Ongoing', 'Step2']
          this.stepsOptions.tips =
            "Please fill in the merchant's basic information"
        }
        if (this.language === 'zh_cn') {
          this.stepsOptions.titleList = ['正在进行中 ', 'Step2']
          this.stepsOptions.tips = '请填写商家基本信息 '
        }
        if (this.language === 'zh_tw') {
          this.stepsOptions.titleList = ['正在進行中 ', 'Step2']
          this.stepsOptions.tips = '請填寫商家基本信息 '
        }
        break
      case 1:
        if (this.language === 'en') {
          this.stepsOptions.titleList = ['Done', 'Ongoing']
          this.stepsOptions.tips =
            'Please go to the edit page under the merchant to add products and agent products.'
        }
        if (this.language === 'zh_cn') {
          this.stepsOptions.titleList = ['完毕', 'Ongoing']
          this.stepsOptions.tips = '请到商户下方的编辑页面添加商品和代理商品。'
        }
        if (this.language === 'zh_tw') {
          this.stepsOptions.titleList = ['完畢', 'Ongoing']
          this.stepsOptions.tips = '請到商戶下方的編輯頁面添加商品和代理商品。'
        }
      default:
        break
    }
  }
  mounted () {
    this.initSteps()
  }
}
